// @LTG-ID: F-017
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 08_FEATURES.md#F-017, source Landing Page.html lines 2182-2209
// @CHANGED: 2026-02 session_003 (CHG-0046)
// @OWNER: web
//
// F-017 — 9 long-form Q&A accordion. Single-expanded (clicking another closes
// the current; clicking the open one closes it). Initial open index = 0 per
// source. Categories appear in left rail; question in middle; +/- toggle right.

import { useState } from "react";
import { OWNER_QUESTIONS } from "../../data/owner-questions";
import ItalicPeriod from "../brand/ItalicPeriod";
import "./owner-questions.css";

export function OwnerQuestions() {
    const [open, setOpen] = useState(0);

    return (
        <section
            className="ltg-oq-section"
            id="owner-questions"
            data-testid="owner-questions-section"
        >
            <div className="ltg-narrow">
                <div className="ltg-block-head">
                    <span
                        className="ltg-eyebrow"
                        data-testid="owner-questions-eyebrow"
                    >
                        Questions every owner asks
                    </span>
                    <h2 data-testid="owner-questions-h2">
                        The honest answers, before you decide
                        <ItalicPeriod />
                    </h2>
                </div>
                <p className="ltg-oq__lede">
                    We sit with thousands of owners a year. Most of them are
                    working through the same nine questions before they decide
                    whether to order. We answer them here, in the same words
                    we use in person, so you do not have to ask.
                </p>
                <div className="ltg-oq__list" data-testid="owner-questions-list">
                    {OWNER_QUESTIONS.map((q, i) => {
                        const isOpen = open === i;
                        return (
                            <div
                                key={q.q}
                                className={
                                    "ltg-oq__item" +
                                    (isOpen ? " ltg-oq__item--open" : "")
                                }
                                data-testid={`oq-item-${i}`}
                            >
                                <button
                                    type="button"
                                    className="ltg-oq__trigger"
                                    onClick={() => setOpen(isOpen ? -1 : i)}
                                    aria-expanded={isOpen}
                                    aria-controls={`oq-answer-${i}`}
                                    data-testid={`oq-trigger-${i}`}
                                >
                                    <span className="ltg-oq__cat">{q.cat}</span>
                                    <span className="ltg-oq__q">{q.q}</span>
                                    <span
                                        className="ltg-oq__icon"
                                        aria-hidden="true"
                                    >
                                        {isOpen ? "–" : "+"}
                                    </span>
                                </button>
                                {isOpen && (
                                    <div
                                        id={`oq-answer-${i}`}
                                        className="ltg-oq__a"
                                        data-testid={`oq-answer-${i}`}
                                    >
                                        {q.a}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}

export default OwnerQuestions;
